import { configureStore } from "@reduxjs/toolkit";
import testSlice1 from "../pages/test/slice";

/* Pass an object full of "slice reducers", and configureStore will call combineReducers for you: */
export const store = configureStore({
  reducer: {
    slice1: testSlice1,
  },
  devTools: process.env.NODE_ENV !== "production",
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
